import { asModal } from 'common/Modal/Modal'
import firebase from 'firebase/app'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Form, {
  FormError,
  FormikFormInput as FormInput,
  FormInputLabel,
  FormButton
} from '../../../../common/components/Form'
import Text, { Paragraph } from '../../../../common/components/Text'
import { LabelSpacer } from '../../../../common/components/Label/Label'
import Icon from '../../../../common/components/Icon'
import { compose } from 'recompose'
import { withFormik } from 'formik'
import { ModalTitle } from '../../../../common/Modal/Modal';

const ReauthModal = ({ email, handleSubmit, isValid }) => {
  const { t } = useTranslation()

  return (
    <>
      <ModalTitle>
        <Text>TODO</Text>
      </ModalTitle>
      <Form onSubmit={handleSubmit}>
        <Paragraph grey>{t('settings.reauth')}</Paragraph>
        <FormInputLabel>{t('auth.modal.signin.password')}</FormInputLabel>
        <input
          type="email"
          defaultValue={email}
          autoComplete="username"
          hidden
        />
        <FormInput
          name="password"
          type="password"
          autoComplete="current-password"
        />
        <FormError name="password" />
        <FormButton type="submit" disabled={!isValid}>
          <Text>{t('auth.modal.continue')}</Text>
          <LabelSpacer />
          <Icon icon="arrow-right" />
        </FormButton>
      </Form>
    </>
  )
}

export default compose(
  asModal({ small: true }),
  withFormik({
    mapPropsToValues: () => ({ password: '' }),

    validate: values => {
      if (!values.password) {
        return { password: 'settings.errors.passwordRequired' }
      } else {
        return {}
      }
    },

    handleSubmit: async (values, { setFieldError, setSubmitting, props }) => {
      const reauthenticated = await firebase
        .auth()
        .currentUser.reauthenticateAndRetrieveDataWithCredential(
          firebase.auth.EmailAuthProvider.credential(
            props.email,
            values.password
          )
        )
        .then(() => true)
        .catch(error => {
          switch (error.code) {
            case 'auth/user-mismatch': //Thrown if the credential given does not correspond to the user.
            case 'auth/user-not-found': //Thrown if the credential given does not correspond to any existing user.
            case 'auth/invalid-credential': //Thrown if the provider's credential is not valid. This can happen if it has already expired when calling link, or if it used invalid token(s). See the Firebase documentation for your provider, and make sure you pass in the correct parameters to the credential method.
            case 'auth/invalid-email': //Thrown if the email used in a firebase.auth.EmailAuthProvider#credential is invalid.
            case 'auth/invalid-verification-code': //Thrown if the credential is a firebase.auth.PhoneAuthProvider#credential and the verification code of the credential is not valid.
              setFieldError('password', 'settings.errors.other')
              break
            case 'auth/wrong-password': //Thrown if the password used in a firebase.auth.EmailAuthProvider#credential is not correct or when the user associated with the email does not have a password.
              setFieldError('password', 'settings.errors.password')
              break
            default:
              break
          }
          return false
        })

      if (reauthenticated) props.submitForm()
      else setSubmitting(false)
    },

    displayName: 'ReauthForm'
  })
)(ReauthModal)
